import React from 'react';
import { Button, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import MentionableEditor from './MentionableEditor';
import { JSONContent } from '@tiptap/react';
import { useMentionableUsers } from '../services/useCommentQueries';

interface CommentEditFormProps {
    value: string;
    onChange: (
        content: string,
        mentions: { id: string; label: string }[],
        json: JSONContent
    ) => void;
    onSubmit: (e: React.FormEvent) => void;
    onCancel: () => void;
    isPending: boolean;
    targetType: 'goal' | 'todo' | 'note' | 'feedback' | 'daily_scrum';
    targetId: string;
}

export const CommentEditForm: React.FC<CommentEditFormProps> = ({
    value,
    onChange,
    onSubmit,
    onCancel,
    isPending,
    targetType,
    targetId,
}) => {
    const { t } = useTranslation();
    const { data: mentionableUsers, isLoading } = useMentionableUsers(
        targetType,
        targetId
    );

    return (
        <Group component="form" gap="xs" ml={22} onSubmit={onSubmit}>
            <MentionableEditor
                mentionableUsers={mentionableUsers || []}
                loadingUsers={isLoading}
                initialContent={value} // 편집 모드에서는 기존 내용을 initialContent로 전달
                onChange={onChange}
                autoFocus={true}
            />
            <Button
                type="submit"
                variant="filled"
                size="xs"
                radius="md"
                disabled={!value.trim() || isPending}
            >
                {t('button.save')}
            </Button>
            <Button variant="subtle" size="xs" radius="md" onClick={onCancel}>
                {t('button.cancel')}
            </Button>
        </Group>
    );
};
